<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :typeslabel="{
        date: '등록일',
      }"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name', 'writer_name', 'date']"
      :options="[
        { type: 'text', label: '작성자', readonly: true },
        { type: 'daterang', label: '사업기간' },
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
      ]"
    />

    <table-inspect-merge
      class="mt-4"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      v-model="form.inspectList"
      title="순회점검표"
      table-header-title="점검항목"
      :table-header-note="[{ text: '비고', width: '300' }]"
      :table-header-check="[
        { text: '양호', value: 'Yes', width: '100' },
        { text: '미흡', value: 'No', width: '100' },
        { text: '해당없음', value: 'N/A', width: '100' },
      ]"
      contentBefore="•"
    />

    <div class="writeGridContainer mt-4">
      <div class="writeGridLineItem">
        <div>지적사항 및 조치내용</div>
        <div>
          <ml-textarea v-model="form.조치내용" rows="5" placeholder="조치내용" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="점검 사진" placeholder="사진내용" />

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 확인자</h5>
      </div>
    </div>

    <div class="writeGridContainer">
      <div>
        <div>점검부서</div>
        <p v-if="isPrint" class="print-input">{{ form.sign1.team }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.sign1.team" />
      </div>
      <div>
        <div>점검자</div>
        <p v-if="isPrint" class="print-input">{{ form.sign1.name }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.sign1.name" placeholder="성명" />
      </div>
      <div>
        <div>서명</div>
        <sign-field v-if="!isPrint" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
        <div v-else class="w-full flex-1 p-1">
          <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
          <div v-else class="signatureImg"></div>
        </div>
      </div>

      <div>
        <div>대상업체</div>
        <p v-if="isPrint" class="print-input">{{ form.sign2.team }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.sign2.team" />
      </div>
      <div>
        <div>업체 관계자</div>
        <p v-if="isPrint" class="print-input">{{ form.sign2.name }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.sign2.name" placeholder="성명" />
      </div>
      <div>
        <div>서명</div>
        <sign-field v-if="!isPrint" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
        <div v-else class="w-full flex-1 p-1">
          <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
          <div v-else class="signatureImg"></div>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "@/views/boards/single-page/1076/inspectData";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    TableInspectMerge,
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.writer) {
          if (!this.form.stdInfo.작성자 || this.form.stdInfo.작성자 === "") {
            const writerName = value.writer && value.writer.name ? value.writer.name : null;
            if (writerName) {
              this.form.stdInfo.작성자 = writerName;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        inspectList: inspectData.inspectTable,
        조치내용: "",
        sign1: {
          team: "",
          name: "",
          sign: "",
        },
        sign2: {
          team: "",
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
